"use client";
// The `useId` hook isn't availble until React 18,
// and we need to support 17 as well
// TODO: Delete in v5 or whenever we stop supporting React 17 apps
import React from "react";

let idLocal = -1;

const IdContext = React.createContext<{ getId: () => string }>({
  getId: () => {
    idLocal = idLocal + 1;
    return `r${idLocal}`;
  }
});

export const IdProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const id = React.useRef(0);

  const getId = React.useCallback(() => {
    id.current = id.current + 1;
    return `r${id.current}`;
  }, []);

  return <IdContext.Provider value={{ getId }}>{children}</IdContext.Provider>;
};

export const useId = () => {
  const { getId } = React.useContext(IdContext);
  const id = React.useMemo(() => getId(), [getId]);
  return id;
};
